import { render } from "./TotalProductionGraph.vue?vue&type=template&id=16c12d30&scoped=true&ts=true"
import script from "./TotalProductionGraph.vue?vue&type=script&lang=ts"
export * from "./TotalProductionGraph.vue?vue&type=script&lang=ts"

import "./TotalProductionGraph.vue?vue&type=style&index=0&id=16c12d30&scoped=true&lang=css"

import exportComponent from "../../../../../../../../build_modules/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c12d30"]])

export default __exports__